import {
  EStatus,
  IHouseOfferHistoryV4Schema,
} from 'shared/repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';

export const getOfferDateEnd = (offer: IHouseOfferHistoryV4Schema): string => {
  return offer.status === EStatus.Published ? 'Активно' : offer.dateEnd || '–';
};
